import type { RuntimeAnswer } from '../../types/runtime';

interface Props {
  answer: RuntimeAnswer;
}

export function TaskCompletedCard({ answer }: Props) {
  const taskAfter = (answer.task_after ?? {}) as Record<string, unknown>;
  const completedAt = typeof taskAfter.completed_at === 'string' ? taskAfter.completed_at : null;
  const title = typeof taskAfter.title === 'string' ? taskAfter.title : null;
  return (
    <article className="rounded-lg border border-emerald-200 bg-emerald-50 p-4 text-sm text-emerald-900">
      <div className="mb-2 flex items-center gap-2">
        <span className="rounded bg-emerald-200 px-2 py-0.5 text-[10px] font-semibold uppercase tracking-wide">
          Done
        </span>
        {completedAt && (
          <span className="text-xs text-emerald-800">at {completedAt.slice(0, 19).replace('T', ' ')}</span>
        )}
      </div>
      <p className="whitespace-pre-line leading-relaxed">{answer.content}</p>
      {title && <p className="mt-1 text-xs text-emerald-700">Task: {title}</p>}
      {answer.audit_id && (
        <p className="mt-2 text-[10px] uppercase tracking-wide text-emerald-700">
          audit: {String(answer.audit_id).slice(0, 8)}
        </p>
      )}
    </article>
  );
}
